
import { useCallback } from "react";
import { PrayerTime } from "@/types/page";

interface UseAutoSaveProps {
  prayerTimes: PrayerTime[];
  blockTitle: string;
  animationSpeed: number;
  saveContent: (
    currentPrayerTimes?: PrayerTime[],
    currentBlockTitle?: string,
    currentAnimationSpeed?: number
  ) => Promise<void>;
  setHasChanges: (value: boolean) => void;
}

export function useAutoSave({
  prayerTimes,
  blockTitle,
  animationSpeed,
  saveContent,
  setHasChanges,
}: UseAutoSaveProps) {
  // Function to update local state without auto-save
  const updateLocalState = useCallback(
    (
      newPrayerTimes?: PrayerTime[],
      newBlockTitle?: string,
      newAnimationSpeed?: number
    ) => {
      // Mark that changes have been made
      setHasChanges(true);
      
      if (newBlockTitle !== undefined) {
        console.log("Updating block title:", newBlockTitle);
      }
      
      if (newPrayerTimes !== undefined) {
        console.log("Updating prayer times:", newPrayerTimes);
      }
      
      if (newAnimationSpeed !== undefined) {
        console.log("Updating animation speed:", newAnimationSpeed);
      }
    },
    [setHasChanges]
  );

  return {
    updateLocalState,
  };
}
